import React from "react"
import { Spinner } from "components/kit"

export default () => (
  <div className="w-100 h-screen flex items-center justify-center bg-gray-200">
    <Spinner />
  </div>
)
